import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { appendClass, subscribe } from '@1inch-community/core/lit-utils';
import { chainViewConfig } from '@1inch-community/sdk/chain';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { fromEvent, tap } from 'rxjs';
import '../../../token-icon';
import { favoriteToken, selectToken } from '../../events';
import { favoriteTokenToggleStyle } from '../../styles/favorite-token-toggle.style';
import { mobileListStyle } from '../../styles/mobile-list.style';
import { tokenItemCrossChainAccordionChainViewStyle } from './token-item-cross-chain-accordion-chain-view.style';
let TokenItemCrossChainAccordionChainViewElement = class TokenItemCrossChainAccordionChainViewElement extends LitElement {
    constructor() {
        super(...arguments);
        this.showFavoriteTokenToggle = false;
        this.mobileView = false;
        this.isFavorite = false;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([tokenId]) => {
            if (!tokenId)
                throw new Error('');
            const token = await this.applicationContext.value.tokenStorage.getTokenById({
                tokenRecordId: tokenId,
            });
            if (!token) {
                console.error('token not found', tokenId);
                throw new Error('');
            }
            return token;
        }, () => [this.tokenId, this.walletAddress]);
    }
    static { this.tagName = 'inch-token-item-cross-chain-accordion-chain-view'; }
    static { this.styles = [
        tokenItemCrossChainAccordionChainViewStyle,
        favoriteTokenToggleStyle,
        mobileListStyle,
    ]; }
    firstUpdated() {
        subscribe(this, [
            fromEvent(this, 'click').pipe(tap(() => {
                if (!this.task.value || !this.task.value)
                    return;
                selectToken(this, this.task.value);
            })),
        ], { requestUpdate: false });
    }
    render() {
        return this.task.render({
            error: () => this.renderChainViewOrLoader(),
            pending: () => this.renderChainViewOrLoader(),
            complete: () => this.renderChainViewOrLoader(),
        });
    }
    renderChainViewOrLoader() {
        if (!this.task.value)
            return this.renderLoader();
        return this.renderChainView(this.task.value);
    }
    renderChainView(token) {
        const chainView = chainViewConfig[token.chainId];
        if (!chainView)
            return this.renderLoader();
        let favoriteIconStyle = {
            border: 'var(--color-content-content-secondary)',
        };
        if (this.isFavorite) {
            favoriteIconStyle = {
                border: 'var(--color-core-orange-warning)',
                body: 'var(--color-core-orange-warning)',
            };
        }
        appendClass(this, {
            'show-favorite-token-toggle': this.showFavoriteTokenToggle,
            'favorite-token': this.isFavorite,
            'mobile-view': this.mobileView,
        });
        return html `
      <div class="left">
        <inch-icon class="corner-icon" icon="cornerDownRight16"></inch-icon>
        <inch-icon icon="${chainView.iconName}"></inch-icon>
        <div>${chainView.name}</div>
      </div>
      <div class="right favorite-icon-overflow">
        <inch-token-balance
          class="balance"
          .tokenId="${this.tokenId}"
          .symbol="${token.symbol}"
          .walletAddress="${this.walletAddress}"
        ></inch-token-balance>
        <inch-token-fiat-balance
          class="fiat-balance"
          .tokenId="${this.tokenId}"
          .symbol="${token.symbol}"
          .walletAddress="${this.walletAddress}"
        ></inch-token-fiat-balance>
      </div>
      ${when(this.showFavoriteTokenToggle, () => html `
          <inch-icon
            class="favorite-icon"
            icon="startDefault16"
            .props="${favoriteIconStyle}"
            @click="${(event) => {
            event.stopPropagation();
            event.preventDefault();
            if (!this.tokenId)
                return;
            this.isFavorite = !this.isFavorite;
            favoriteToken(this, [this.isFavorite, this.tokenId]);
        }}"
          ></inch-icon>
        `)}
    `;
    }
    renderLoader() {
        return html ``;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainAccordionChainViewElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainAccordionChainViewElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainViewElement.prototype, "showFavoriteTokenToggle", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainViewElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainViewElement.prototype, "isFavorite", void 0);
TokenItemCrossChainAccordionChainViewElement = __decorate([
    customElement(TokenItemCrossChainAccordionChainViewElement.tagName)
], TokenItemCrossChainAccordionChainViewElement);
export { TokenItemCrossChainAccordionChainViewElement };
//# sourceMappingURL=token-item-cross-chain-accordion-chain-view.element.js.map